module.exports = __webpack_public_path__ + "img/ico-total-facturas.ccd5e794.svg";